export function formatClockTime(value: string): string {
    const startMatch = /^(\d{2}):(\d{2})/.exec(value)
    if (startMatch) {
        const [, hour, minute] = startMatch
        return `${hour}:${minute}`
    }

    const embeddedMatch = /T(\d{2}):(\d{2})/.exec(value)
    if (embeddedMatch) {
        const [, hour, minute] = embeddedMatch
        return `${hour}:${minute}`
    }

    return value
}
